import { render, staticRenderFns } from "./IconEstado.vue?vue&type=template&id=5ad15a92"
import script from "./IconEstado.vue?vue&type=script&lang=js"
export * from "./IconEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports